<template>
    <div>
        <div class="hh-input-label-wrapper">
          <label :for="componentId" v-if="(withLabel || !enabled) && label" class="hh-input-label">{{label}}</label>
           <label :for="componentId" v-if="(withLabel || !enabled) && !label" class="hh-input-label">{{placeholder}}</label>
            <input
                    :id="componentId"
                    :class="allCssClasses"
                    :maxlength='maxlength'
                    :type="type"
                    :autocomplete="autocomplete"
                    :required="required"
                    v-model="displayValue"
                    @input="$emit('input', $event.target.value)"
                    @focus="enabled = true"
                    @blur="blurAction"
                    :placeholder="placeholder"
            >
          
          <div v-if="note" class="form-group">
            <div class="margin-top-10 margin-left-0 hint-text">{{note}}</div>
          </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'InputLabel',

    props: {
      value: {
        type: String,
      },
      note: {
        type: String,
      },
      label: {
        type: String
      },
      cssClass: String,
      id: {
        type: String,
      },
      maxlength: {
        type: Number,
        default: 250,
      },
      type: {
        default: 'text',
        type: String
      },
      placeholder: String,
      autocomplete: {
        default: 'nope',
        type: String
      },
      required: {
        default: false,
        type: Boolean
      },
      withLabel: {
        default: true,
        type: Boolean
      },
    },

    beforeMount () {
      // this.inputValue = this.value
    },


    data: () => {
      return {
        // inputValue: null,
        enabled: false,
      }
    },

    methods: {
      blurAction (event) {
        // this.$emit('blur', event.target.value)
        this.enabled = false
      },
    },

    computed: {
      displayValue: {
        get: function() {
          return this.value
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      },
      componentId () {
        if (this.id == null) {
          return `input-label-${this._uid}`
        }
        return this.id
      },

      allCssClasses () {
        let result = this.cssClass

        if (!_.isEmpty(this.value)) {
          result += ' hh-label-active'
        }

        return result
      },
    },

  }
</script>

<style scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>